import { useTranslation } from "react-i18next";

function LoadingBar({ width = "70%", className = "" }) {
    return <span className={`scan-loading-bar ${className}`} style={{ "--loading-width": width }} />;
}

export default function ScanLoading({ variant = "list" }) {
    const { t } = useTranslation();
    const label = variant === "report" ? "Chargement du scan…" : "Chargement des scans…";

    return (
        <div className="scan-loading" role="status">
            <span className="scan-loading-label">{t(label)}</span>
            {variant === "workflow-table" ? (
                <div className="scan-results-loading" aria-hidden="true">
                    <div className="scan-results-loading-toolbar">
                        <LoadingBar width="100%" />
                    </div>
                    <div className="scan-results-loading-table scan-results-loading-table--workflow">
                        <div className="scan-results-loading-row scan-results-loading-row--header">
                            {["58%", "72%", "62%", "44%"].map((width, index) => (
                                <LoadingBar width={width} key={index} />
                            ))}
                        </div>
                        {Array.from({ length: 6 }, (_, index) => (
                            <div className="scan-results-loading-row" key={index}>
                                <LoadingBar width={`${58 + (index % 3) * 10}%`} />
                                <LoadingBar width={`${68 - (index % 2) * 12}%`} />
                                <LoadingBar width="118px" className="scan-results-loading-status" />
                                <LoadingBar width="64px" className="scan-results-loading-action" />
                            </div>
                        ))}
                    </div>
                </div>
            ) : variant === "table" ? (
                <div className="scan-results-loading" aria-hidden="true">
                    <div className="scan-results-loading-toolbar">
                        <LoadingBar width="100%" />
                    </div>
                    <div className="scan-results-loading-table">
                        <div className="scan-results-loading-row scan-results-loading-row--header">
                            {["58%", "72%", "62%", "48%", "44%"].map((width, index) => (
                                <LoadingBar width={width} key={index} />
                            ))}
                        </div>
                        {Array.from({ length: 6 }, (_, index) => (
                            <div className="scan-results-loading-row" key={index}>
                                <LoadingBar width={`${58 + (index % 3) * 10}%`} />
                                <LoadingBar width={`${68 - (index % 2) * 12}%`} />
                                <LoadingBar width="72px" className="scan-results-loading-status" />
                                <span className="scan-results-loading-score">
                                    <span className="scan-results-loading-ring" />
                                    <LoadingBar width="18px" />
                                </span>
                                <LoadingBar width="48px" className="scan-results-loading-action" />
                            </div>
                        ))}
                    </div>
                </div>
            ) : variant === "list" ? (
                <div className="scan-history-list" aria-hidden="true">
                    {Array.from({ length: 6 }, (_, index) => (
                        <div className="scan-history-item scan-loading-card" key={index}>
                            <LoadingBar width={`${65 + (index % 3) * 8}%`} />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="scan-page-content-body-content" aria-hidden="true">
                    <div className="scan-metric">
                        {Array.from({ length: 4 }, (_, index) => (
                            <div className="scan-metric-cards scan-loading-card" key={index}>
                                <LoadingBar width="58px" className="scan-loading-icon" />
                                <div className="scan-loading-lines">
                                    <LoadingBar width="48px" className="scan-loading-value" />
                                    <LoadingBar width="85%" />
                                    <LoadingBar width="65%" />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="scan-charts">
                        {Array.from({ length: 3 }, (_, index) => (
                            <div className="scan-charts-content scan-loading-card" key={index}>
                                <LoadingBar width="55%" />
                                <LoadingBar width="75%" />
                                <div className="scan-loading-chart">
                                    <LoadingBar width="150px" className="scan-loading-ring" />
                                    <div className="scan-loading-lines">
                                        <LoadingBar width="90%" />
                                        <LoadingBar width="65%" />
                                        <LoadingBar width="80%" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <LoadingBar width="210px" className="scan-loading-heading" />
                    <div className="scan-charts scan-charts--bottom">
                        {Array.from({ length: 3 }, (_, index) => (
                            <div className="scan-charts-content scan-loading-card" key={index}>
                                <LoadingBar width="60%" />
                                <div className="scan-loading-bars">
                                    {[88, 72, 58, 42, 30].map(width => <LoadingBar key={width} width={`${width}%`} />)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
